// extracted by mini-css-extract-plugin
module.exports = {"procedureName":"styles_procedureName__2O3ZU","colMin":"styles_colMin__1RpWR","colCheckbox":"styles_colCheckbox__14HlY"};